<template>
  <v-card elevation="7">
    <v-row class="bm-0 mb-0 pb-0">
      <v-col cols="12">
        <v-card-subtitle class="ml-2">
          <h2 class="text-uppercase indigo--text">
            {{ currentUser.nombre }} {{ currentUser.primer_apellido }} {{ currentUser.segundo_apellido }}
          </h2>
          <h4 class="text-uppercase" style="color: #616161">
            {{ currentUser.roles[0].descripcion }}
          </h4>
          <v-divider class="mt-3"/>
        </v-card-subtitle>
      </v-col>
      <v-col cols="12" class="mt-0">
        <v-card class="mx-4" color="#CED7DB">
          <v-toolbar color="#286090" dark dense>
            <v-toolbar-title class="text-uppercase">Registro de Tocas</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mx-2">
      <v-spacer></v-spacer>
      <v-col cols="4" md="6" class="pt-0">
        <v-autocomplete
          :items = "listSalas"
          label="Seleccione una Sala"
          item-text="nombre"
          item-value="id"
          persistent-hint
          v-model="sala_id"
          required
          :rules="[v => !!v || 'Campo requerido']"
          key="id"
          :loading="loading"
          v-if="roleUser == 'superadmin' "
          @change="clearSearch()"
        />
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="5" class="pt-0" v-if="sala_id">
        <v-text-field
          placeholder="Buscar Toca"
          v-model="buscar"
          hint="Ej. 1/2023"
          :loading="loading"
          clearable
          @click:clear="clearSearch"
          v-on:keyup.enter="searchToca"
          append-outer-icon="mdi-magnify"
          @click:append-outer="searchToca"
          @keyup="buttons_on_alert = false"
        >
          <!-- @keyup="buttons_on_alert = false, btn_JO = false, btn_JT = false" -->
        </v-text-field>
      </v-col>
    </v-row>
    <!-- <div align="right" class="mr-13 mt-2">
      <v-btn small color="grey darken-2" dark
        v-if="btn_JT"
        @click="dialogFormToca=!dialogFormToca, tipo_juicio = 'JT'">
        Registrar Toca - Juicio Tradicional
      </v-btn>
      <v-btn small color="grey darken-2" dark
        v-if="btn_JO"
        @click="dialogFormToca=!dialogFormToca, tipo_juicio = 'JO'">
        Registrar Toca - Juicio Oral
      </v-btn>
    </div> -->

    <v-row class="mx-2 mt-0" v-if="sala_id">
      <v-col cols="12">
        <v-card class="mx-auto">
          <div class="text-center mb-1">
            <v-toolbar-title>
              <h3 v-if="this.numero && this.anio">RESULTADOS DE LA BÚSQUEDA</h3>
              <h3 v-else>LISTA DE TOCAS</h3>
            </v-toolbar-title>
          </div>
          <v-skeleton-loader
            v-if="!listTocas"
            type="article"
          ></v-skeleton-loader>

          <!-- MOSTRAR LISTADO -->
          <v-card v-if="listTocas && listTocas.length" v-for="(toca, i) in listTocas" :key="i">
            <v-toolbar-title style="background-color: #9c6f05;height: 45px;">
              <div class="text-center mb-1" style="color: white;margin-top: 8px;">
                <b>Toca: {{ toca.numero }}/{{ toca.anio }}<span v-if="toca.complemento">-{{ toca.complemento}}</span>
                ({{ toca.tipo_juicio == 'JO' ? 'Juicio Oral' : 'Jucio Tradicional' }})</b>
              </div>
            </v-toolbar-title>
            <v-list v-if="listTocas">
              <span v-for="(item, i) in toca.apelaciones"
                :key="item.id">
                <v-list-group no-group>
                  <template v-slot:activator>
                    <div>
                      <b>RECEPCIÓN - <span>{{item.created_at | formatDate}}</span></b>
                    </div>
                    <v-spacer></v-spacer>
                  </template>
                  <v-list-item-content>
                    <TableDetallesApelacion :apelacion="item" />
                    <component v-if="item.hash"
                      :is="eApelacion"
                      :hash="item.hash"
                      :sala_id="currentUser.sala_id"
                      :index="item.id">
                    </component>
                  </v-list-item-content>
                </v-list-group>
                <v-divider></v-divider>
              </span>
            </v-list>
            <!-- ACCIONES PARA EL TOCA -->
            <div class="text-center font-weight-bold text-uppercase mt-2">
              <!-- <v-btn
                v-if="toca.last_apelacion.status == 45"
                outlined
                color="primary"
                @click="addTocaApelacion(toca)"
                small
              >
                AGREGAR APELACIÓN
              </v-btn> -->
              <!-- <v-btn
                v-if="toca.last_apelacion.status == 10 || toca.last_apelacion.status == 20 || toca.last_apelacion.status == 70"
                @click="addExcusa(toca)"
                outlined
                color="red"
                class="ml-1"
                small
              >
                EXCUSAR TOCA
              </v-btn> -->
              <!-- <v-btn
                v-if="toca.last_apelacion.status == 50"
                @click="addReturno(toca)"
                outlined
                color="green"
                class="ml-1"
                small
              >
                RETURNAR
              </v-btn> -->
            </div>
            <v-divider class="mt-2 mb-3"></v-divider>
          </v-card>
          <div class="text-center pt-2" v-if="pageCount>1">
            <v-pagination
              v-model="current"
              :length="pageCount"
              :total-visible='7'
              @input="getTocas()"
            ></v-pagination>
          </div>

          <!-- MENSAJE NO HAY DATOS -->
          <v-alert v-if="listTocas && !listTocas.length"
            text
            outlined
            prominent
            type="error"
          >
            <v-row align="center">
              <v-col class="grow text-uppercase">
                <h4 v-if="status.value">No hay Tocas por mostrar!!!</h4>
                <h4 v-else>Toca no registrado!!!</h4>
              </v-col>
              <v-col class="shrink mt-n2 mb-n2"  v-if="numero && anio && buttons_on_alert">
                <v-btn small color="grey darken-2" dark
                  @click="tipo_juicio = 'JT', dialogFormToca=!dialogFormToca, accion_form_toca='add'">
                  Registrar Toca - Juicio Tradicional
                </v-btn>
                <br>
                <v-btn small color="grey darken-2" dark
                  style="min-width: 289px;"
                  @click="tipo_juicio = 'JO', dialogFormToca=!dialogFormToca, accion_form_toca='add'" class="mt-2">
                  Registrar Toca - Juicio Oral
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>

        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog componente FormToca -->
    <v-dialog
      persistent
      v-model="dialogFormToca"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    ><FormToca
        v-if="dialogFormToca"
        :sala_id="sala_id"
        :num_toca="buscar"
        :toca="toca_selected"
        :tipo_juicio="tipo_juicio"
        :accion="accion_form_toca"
        @reloadTocas="getTocas(), toca_selected=''"
        @closeModal="dialogFormToca=false, toca_selected=''"
      ></FormToca>
        <!-- @reloadTocas="getTocas(), toca_selected='', buscar=''" -->
    </v-dialog>
    <!-- Fin Dialog componente FormToca -->

  </v-card>
</template>

<script>
  import FormToca from "../../components/FormToca";
  import ApelacionElectronica from "@/components/ApelacionElectronica";
  import TableDetallesApelacion from "@/components/TableDetallesApelacion";
  // import Asignar from "../../components/Asignar";

  import { mapMutations } from "vuex";
  import { mapGetters } from "vuex";

  export default {
    components: {
       FormToca, ApelacionElectronica, TableDetallesApelacion
    },
    props: {
      source: String
    },
    data() {
      return {
        valid: false,
        dialogFormToca: false,
        accion_form_toca: '',
        listTocas: null,
        toca_selected: '',
        tipo_juicio: '',
        btn_JT: false,
        btn_JO: false,
        buttons_on_alert: false,
        apelacion_selected: '',
        current:1,
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        status: { "text": "REGISTRADAS", "value": 10, "align": "", "sortable": true, "width": "" },
        loading: true,
        buscar: '',
        sala_id: '',
        anio:'',
        numero:'',
        complemento:'',
        items_status: [
          { text: "REGISTRADAS", value: 10, align: "", sortable: true, width: '' },
        ],
        hash:"",
        eApelacion:"ApelacionElectronica",
        rules: {
          required:v => !!v || 'Campo requerido',
          requiredSelect:v => !!v|| 'Campo requerido'
        }
      };
    },
    computed: {
      ...mapGetters(["listSalas", "roleUser", "currentUser"])
    },
    created() {
      if (this.roleUser == 'superadmin') {
        this.loading = false
        return false;
      } else {
        let user = JSON.parse(localStorage.getItem('user'));
        this.sala_id = user.sala_id
      }
      this.getTocas();
    },
    methods: {
      getTocas(){
        // this.dialogFormToca = false
        this.dialogReturno = false
        this.loading = true
        this.listTocas = null
        this.$store.dispatch("GET_TOCAS", {
          url: "/tocas/list",
          params: {
            page: this.current,
            sala_id:  this.sala_id,
            anio:  this.anio || undefined,
            numero:  this.numero || undefined,
            derivado:  this.complemento || undefined
          }
        }).then(response => {
          this.loading = false
          this.buttons_on_alert = true
          this.current = response.data.data.toca.current_page;
          this.pageCount = response.data.data.toca.last_page;
          this.listTocas = response.data.data.toca.data || response.data.data.toca
          this.checkButtons()
        });
      },
      checkButtons(){
        if (this.buscar != '') {
          this.btn_JO = false
          this.btn_JT = false
          if(this.listTocas.length==1 && this.listTocas[0].tipo_juicio == 'JO'){
            this.btn_JT = true
          }
          if(this.listTocas.length==1 && this.listTocas[0].tipo_juicio == 'JT'){
            this.btn_JO = true
          }
          if (this.listTocas.length==2 || this.listTocas.length==0) {
            this.btn_JO = false
            this.btn_JT = false
          }
        }
      },
      searchToca(){
        if (!this.buscar) return false;
        if (this.buscar.length >= 5 ) {
          if ( this.buscar.includes("/") ) var tocacompleto = this.buscar.replace('/','');
          else var tocacompleto = this.buscar;

          this.complemento = tocacompleto.split('-').splice(1).join('-');
          var tocacompleto = tocacompleto.split('-')[0];
          this.anio = tocacompleto.substr(tocacompleto.length - 4);
          this.numero = tocacompleto.slice(0, tocacompleto.length - 4);

          if (this.anio && this.numero) {
             this.getTocas()
          } else {
            this.$swal({
              title: "Error",
              text: "Favor de verificar el formato del toca!!!",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        }
      },
      clearSearch () {
        this.numero = ''
        this.anio = ''
        this.getTocas()
      },
    }
  };
</script>
